import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import Window from "../../../../../lib/components/window/Window";
import Entity from "../Entity";
import TableButtonGroup from "../tableButtonGroup/TableButtonGroup";
import React, {createRef} from "react";
import TabBarHorizontal from "../../../../../lib/components/tabbar/TabBarHorizontal";
import TabContent from "../../../../../lib/components/tabbar/TabContent";
import TabContainerHorizontal from "../../../../../lib/components/tabbar/TabContainerHorizontal";
import DataSource from "../../../../../lib/model/service/dataSource/DataSource";
import CM from "../../../../model/system/CM";
import DetailFieldsViewForm from "./DetailFieldsViewForm";
import EntityDescribe from "../../../../../lib/model/service/entity/dto/EntityDescribe";
import ButtonTab from "../../../../../lib/components/tabbar/ButtonTab";
import DataSourceLink from "../../../../../lib/model/service/dataSource/DataSourceLink";
import GF from "../../../../../lib/utils/GF";
import shortid from "shortid";
import RelationForm from "../relation/RelationForm";
import TableNameOutputLine from "../../../../model/oms/OutputLine";
import {SettingsEthernet} from "@mui/icons-material";
import MenuItem from "../../menu/MenuItem";
import InputDropDown from "../../inputFields/dropdown/InputDropDown";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import HorizontalTabBar from "../../tabbar/HorizontalTabBar";
import BaseTab from "../../tabbar/BaseTab";

class EntityForm extends BaseComponent {

  static getForeignRelation(dataSource, mainRelation) {
    let relation = null;
    for (let i = 0; i < dataSource.entityDef.relations.length; i++) {
      let foreignRelation = dataSource.entityDef.relations[i];

      if (foreignRelation.name[0] === mainRelation.name[1] && foreignRelation.name[1] === mainRelation.name[0]) {
        relation = foreignRelation;
        break;
      }
    }
    return relation;
  }

  constructor(props) {
    super(props);
    this.detailContainerRef = createRef();
    this.relationTabContainerRef = createRef();
    this.entityRef = createRef();
    this.relatedEntitiesRef = {};
    this.relationsInfo = [];
    this.dataSourceMaster = this.initDataSource(this.props.entityDef, this.props.campaignId, this.props.dtoProperties,
      this.props.tabId);
    this.state = {
      omsDialog: null, anchorEl: null
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.initEntityRelations();
  }

  addEntityToTab(entityDef, relationDataSource, foreignRelation, tableName) {
    let tableLabel = entityDef.baseDef.description;
    if (GF.checkNotNull(this.props.campaignId)) {
      tableLabel = this.props.campaignId + ':' + tableLabel;
    }
    let tabId = this.props.campaignId + ':' + tableName;
    this.relatedEntitiesRef[tabId] = createRef();

    new DataSourceLink(this.dataSourceMaster, relationDataSource, foreignRelation);

    if (this.relationTabContainerRef.current != null) {
      this.relationTabContainerRef.current.addTab(<BaseTab tabTitle={tableLabel} notClosable/>,
        <Window className='text-cn-color-white'
                id={tabId}
                title={entityDef.baseDef.description}>
          <Entity dataSource={relationDataSource}
                  ref={this.relatedEntitiesRef[tabId]}
                  headerButtons={<TableButtonGroup ref={createRef()} tableName={relationDataSource.entityDef.baseDef.name} editable/>}
                  tabContainer={this.relationTabContainerRef.current}
                  parent={this}
                  campaignId={this.props.campaignId}
                  autoload={false}/>
        </Window>);
    }
  }

  doClearCache() {
    this.dataSourceMaster.doClearCache();

    for (let foreignTableName in this.relationsInfo) {
      let relationInfo = this.relationsInfo[foreignTableName];
      relationInfo.relationDataSource.doClearCache();
    }
  }

  initDataSource(entityDef, campaignId, dtoProperties, persistanceKeyPrefix) {
    return DataSource.generateDatasource(entityDef, campaignId,
      (datasource, dto, dataSourceDtoProcessEvents) => DataSource.datasourceDataHandler(datasource, dto,
        dataSourceDtoProcessEvents), dtoProperties, persistanceKeyPrefix);
  }

  initEntityRelations() {
    this.relationsInfo = [];
    let numOfRelations = Object.keys(this.props.entityDef.relations).length;
    let i = 0;
    for (let fieldKey in this.props.entityDef.relations) {
      if (this.props.entityDef.relations.hasOwnProperty(fieldKey)) {
        let relation = this.props.entityDef.relations[fieldKey];

        let dtoDescribeTable = new EntityDescribe([relation.foreignRelation]);
        dtoDescribeTable.setProperties(this.dataSourceMaster.getDtoProperties());

        CM.get().doJsonAjaxCache(CM.get().getServiceUrl('DoctrineEntityService'), dtoDescribeTable, (response) => {
          i++;
          if (response.success) {
            let foreignEntityDef = response.data.serviceDescription.entityDefs[0];
            let relationDataSource = this.initDataSource(foreignEntityDef, this.props.campaignId,
              this.props.dtoProperties, this.props.tabId);

            let foreignRelation = EntityForm.getForeignRelation(relationDataSource, relation);
            this.relationsInfo[foreignEntityDef.baseDef.name] = {
              relation: relation,
              foreignRelation: foreignRelation,
              relationEntityDef: foreignEntityDef,
              relationDataSource: relationDataSource
            };
            if (i === numOfRelations) {
              this.initEntityRelationsDone();
            }
          }
        }, DataSource.buildEntityCacheKey(this.props.campaignId, relation.foreignRelation, 'EntityDescribe'));
      }
    }
  }

  initEntityRelationsDone() {
    for (let foreignTableName in this.relationsInfo) {
      let relationInfo = this.relationsInfo[foreignTableName];
      this.addEntityToTab(relationInfo.relationEntityDef, relationInfo.relationDataSource, relationInfo.foreignRelation,
        foreignTableName);
    }
    this.setState(this.state);
  }

  initTableGroupButton() {
    let tableGroupButton;
    let additionalTableButtons = [];

    if (this.props.entityDef.relations.length > 0) {
      let relationMenuItems = [];
      for (let foreignTableName in this.relationsInfo) {
        let relationInfo = this.relationsInfo[foreignTableName];
        if (foreignTableName !== TableNameOutputLine) {
          relationMenuItems.push(
            <MenuItem key={shortid()} value={relationInfo}>{relationInfo.relation.name[1]}</MenuItem>);
        }
      }
      additionalTableButtons.push(
        <InputDropDown size='small' width={220} key={shortid()} ref={createRef()} labelElement='Datensätze verknüpfen'
                       onChange={(e, id, relationInfo) => this.openRelationTab(relationInfo, this.props.campaignId)}>
          {relationMenuItems}
        </InputDropDown>);
    }

    for (let index in this.props.additionalTableButtons) {
      let tableButton = this.props.additionalTableButtons[index];
      additionalTableButtons.push(tableButton);
    }
    if (GF.checkNotNull(additionalTableButtons) && additionalTableButtons.length) {
      tableGroupButton = <TableButtonGroup ref={createRef()} tableName={this.props.entityDef.baseDef.name} editable>{additionalTableButtons}</TableButtonGroup>;
    } else {
      tableGroupButton = <TableButtonGroup ref={createRef()} tableName={this.props.entityDef.baseDef.name} editable/>;
    }
    return tableGroupButton;
  }

  openRelationTab(relationInfo, campaignId) {

    this.props.tabMainContainer.addTab(<BaseTab tabTitle={campaignId + ':' + relationInfo.relation.name[1]}/>,
      <RelationForm ref={createRef()}
                    relationInfo={relationInfo}
                    relation={relationInfo.relation}
                    campaignId={campaignId}
                    tabMainContainer={this.props.tabMainContainer}
                    dataSourceMaster={this.dataSourceMaster}/>);
  }

  render() {
    let tableGroupButton = this.initTableGroupButton();
    return <VerticalLayout className='CNINFO-EntityForm entity-form-root gap-3' id={this.props.tabId}>
      {this.state.omsDialog && this.state.omsDialog}
      <Window title={this.props.entityDef.baseDef.description}>
        <Entity ref={this.entityRef} dataSource={this.dataSourceMaster} headerButtons={tableGroupButton} parent={this} isMainTable={this.props.isMainTable} campaignId={this.props.campaignId} tabContainer={this.props.tabMainContainer} functionElements={this.props.functionElements}/>
      </Window>
      <DetailFieldsViewForm dataSource={this.dataSourceMaster}/>
      <HorizontalTabBar className='CNINFO-EntityForm-TabContainer' ref={this.relationTabContainerRef}/>
    </VerticalLayout>;
  }
}

EntityForm.propTypes = {
  entityDef: PropTypes.object,
  tabMainContainer: PropTypes.object,
  campaignId: PropTypes.any,
  tabId: PropTypes.string,
  dtoProperties: PropTypes.object,
  additionalTableButtons: PropTypes.array,
  functionElements: PropTypes.node,
  isMainTable: PropTypes.string
}
export default EntityForm;
